export const getQuotasSchedule = () => ({ quota: 12, enabledSegment: true });



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/quotaSchedule.js